export const IconThumbsUpFill = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.81079 5.88184C3.81079 5.46762 3.475 5.13184 3.06079 5.13184H1.09863C0.684419 5.13184
    0.348633 5.46762 0.348633 5.88184V14.3525C0.348633 14.7667 0.684419 15.1025 1.09863 15.1025H3.06079C3.475
    15.1025 3.81079 14.7667 3.81079 14.3525V5.88184Z"
      fill="currentColor"
    />
    <path
      d="M10.9771 15.0712L10.9441 15.0692C7.457 14.8597 6.93643 13.9576 5.00342 13.6895V6.1361C5.09354 6.05779
    5.18667 5.97152 5.28654 5.87651C6.31672 4.89641 6.93339 3.78386 6.93339 2.16546C6.93339 -0.0911405 9.87866 0.965462
    9.87866 2.9788V5.57213C9.87866 6.30851 10.4757 6.90548 11.212 6.90548H14.3131C15.9496 6.90548 15.3809 12.0499 13.6937
    14.2132C12.9327 15.1888 12.1134 15.1395 10.9771 15.0712Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
